/**
 * PhotoSwipe product-image zoom.
 * This is an alternate to the default cursor-follow zoom (component-product-image-zoom.js).
 * It is only loaded/initialised when a gallery has data-zoom-style="photoswipe".
 *
 * Requires (loaded before this file):
 *   - photoswipe.umd.min.js            -> window.PhotoSwipe
 *   - photoswipe-lightbox.umd.min.js   -> window.PhotoSwipeLightbox
 */
(function () {

	if ( typeof window.PhotoSwipeLightbox === 'undefined' || typeof window.PhotoSwipe === 'undefined' ) {
		return;
	}

	var instances = new WeakMap();

	function initGallery( galleryEl ) {

		if ( ! galleryEl || instances.has( galleryEl ) ) {
			return;
		}

		var lightbox = new window.PhotoSwipeLightbox({
			gallery: galleryEl,
			children: 'a.pswp-zoom-link',
			pswpModule: window.PhotoSwipe,
			showHideAnimationType: 'zoom',
			bgOpacity: 0.9,
			padding: { top: 20, bottom: 20, left: 20, right: 20 },
			wheelToZoom: true
		});

		// Keep PhotoSwipe's active slide roughly in sync with whichever
		// slide the Swiper gallery is currently showing.
		lightbox.on('beforeOpen', function () {
			var swiper = galleryEl.swiper || window.gallerySwiper;
			if ( swiper && typeof lightbox.pswp === 'undefined' ) {
				var activeSlide = swiper.slides[ swiper.activeIndex ];
				if ( activeSlide ) {
					var link = activeSlide.querySelector('a.pswp-zoom-link');
					var links = Array.prototype.slice.call( galleryEl.querySelectorAll('a.pswp-zoom-link') );
					var index = links.indexOf( link );
					if ( index > -1 ) {
						lightbox.options.index = index;
					}
				}
			}
		});

		lightbox.init();
		instances.set( galleryEl, lightbox );
	}

	function initAll( scope ) {
		var root = scope || document;
		var galleries = root.querySelectorAll('[data-zoom-style="photoswipe"]');
		galleries.forEach( initGallery );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', function () { initAll(); });
	} else {
		initAll();
	}

	// Re-init when a section is added/edited in the theme editor.
	document.addEventListener('shopify:section:load', function ( event ) {
		initAll( event.target );
	});

})();
